import Section from '../Section';
import KenBurns from '../global/KenBurns';

export default class ImageGallery extends Section {
  constructor(theme, element, pageLoad) {
    super(theme, element, pageLoad);

    this.kenBurns = new KenBurns(theme, element);

    // For reveal button on hover animation
    this.hiddenButton = this.element.querySelector('.content-grid-item__text--reveal-btn-on-hover .content-grid-item__button');
    this.setButtonHeightVar();
  }

  setButtonHeightVar() {
    if (!this.hiddenButton) return;

    const buttonHeight = Math.max(30, this.hiddenButton.offsetHeight || 0);
    this.element.style.setProperty('--gallery-item-height', `${buttonHeight}px`);
  }
}
